export const BACKGROUND_FILE_SIZE   =   26214400;   // 25 MB
export const LOGO_FILE_SIZE         =   10485760;   // 10 MB
export const DEFAULT_HEADING        =   'Lorem ipsum dolor sit amet';
export const DEFAULT_SUBHEADING     =   'We’re looking for great people to join our growing team.';
export const LOGO_FILE              =   '/images/pages/career/LOGO.png'